import Vue from 'vue'
import Component from 'vue-class-component'
import userStore from '../../store/user/user-store'

@Component({
  name: 'shareButton',
  props: ['type', 'id']
})
export default class ShareButton extends Vue {

  protected copyUrl (): void {
    console.log('copyUrl: full url = %j', window.location)
    let url = window.location.origin + '/' + this.$props['type'] + '/?id=' + this.$props['id'];

    (this as any).$copyText(url).then(() => {
      (this as any).$snotify.success('Link copied to clipboard')
    }).catch((err: any) => {
      (this as any).$snotify.success('Cannot copy link')
      console.log('Error in copyUrl: %j', err)
    })
  }

  protected unfollowUser (): void {
    userStore.dispatchUnfollowUser(this.$props['user'])
  }

}
